import CheckboxIndeterminateIcon from '../Icon/CheckboxIndeterminateIcon.js';
import CheckboxIcon from '../Icon/CheckboxIcon.js';

//
var script = {
  name: 'Checkbox',
  components: {
    CheckboxIcon,
    CheckboxIndeterminateIcon
  },
  model: {
    prop: 'checked',
    event: 'input'
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Object, Number],
      default: undefined
    },
    checked: {
      type: [Boolean, Array],
      required: true
    },
    isFocused: {
      type: Boolean,
      default: false
    },
    isInvalid: {
      type: Boolean,
      default: false
    },
    indeterminate: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      id: undefined
    };
  },

  computed: {
    isChecked: {
      get() {
        return this.checked;
      },

      set(value) {
        this.$emit('input', value);
      }

    }
  },
  watch: {
    isFocused: {
      handler(isFocused) {
        if (isFocused) {
          this.$nextTick(() => this.$refs.input.focus());
        }
      },

      immediate: true
    }
  },

  created() {
    // eslint-disable-next-line
    this.id = this._uuid;
  },

  methods: {
    onBlur(e) {
      if (!this.$refs.checkbox.contains(e.relatedTarget)) {
        this.$emit('blur', e);
      }
    },

    onFocus(e) {
      this.$emit('focus', e);
    }

  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Checkbox/Checkbox.vue_rollup-plugin-vue=script.js